import Vue from "vue";
import { TableauCategoryMapByName, TableauDefaultCategory, UserSettingKeys } from "@/lib/utilities/enums.js";
import { arrayToObj } from "@/lib/utilities";

const state = {
    tableauViews: [],
    reportsSettings: null
};

const getters = {
    TableauCategoryMap(state) {
        const usedCategories = Object.values(TableauCategoryMapByName).filter(category => state.tableauViews.find(tv => tv.CategoryId == category.id));
        return arrayToObj(usedCategories, "id");
    },
    TableauCategories(state, getters) {
        return Object.values(getters.TableauCategoryMap).sort((a, b) =>
            // Sort default names LAST
            (!a.name || a.name == TableauDefaultCategory.name ? "~~~~~" : a.name).toLowerCase() >
                (!b.name || b.name == TableauDefaultCategory.name ? "~~~~~" : b.name).toLowerCase()
                ? 1
                : -1
        );
    },
    TableauViews(state, getters) {
        let updatedViews = (state.tableauViews || []).map(tv => ({
            ...tv,
            Category: getters.TableauCategoryMap[tv.CategoryId] || TableauDefaultCategory,
            IsPrimary: state.reportsSettings && state.reportsSettings.primaryViewId == tv.Id
        }));
        updatedViews.sort((view1, view2) => {
            if (view1.IsPrimary != view2.IsPrimary) return view1.IsPrimary > view2.IsPrimary ? -1 : 1;
            else return (view1.Name || "").toLowerCase() > (view2.Name || "").toLowerCase() ? 1 : -1
        });
        return updatedViews;
    },
    TableauFavoriteViews(state, getters) {
        return (getters.TableauViews || []).filter(tv => tv.IsFavorite);
    },
    ReportsSettings(state) {
        return state.reportsSettings;
    }
}

const actions = {
    async getTableauViews(context) {
        const response = await Vue.http.get("/pando/analytics/tableau/getuserviews").catch(err => err.response);
        context.commit("gotTableauViews", response && response.data ? response.data.Data : []);
        return response;
    },
    async favoriteTableauView(context, view) {
        const response = await Vue.http.post(`/pando/analytics/tableau/${view.Id}/markfavorite`).catch(err => err.response);
        if (response && response.data && response.data.Success) context.commit("updateTableauView", view);
        return response;
    },
    async getReportsSettings(context) {
        const response = await context.dispatch("getUserSettings", UserSettingKeys.REPORTS_SETTINGS).catch(err => err.response);
        if (response && response.Value) context.commit("updateReportsSettings", JSON.parse(response.Value || "{}"));
    },
    async updateReportsSettings(context, settings) {
        const settingsRequest = {
            key: UserSettingKeys.REPORTS_SETTINGS,
            request: settings
        };
        const response = await context.dispatch("saveUserSettings", settingsRequest).catch(err => err.response);
        if (response && response.data && response.data.Success) context.commit("updateReportsSettings", settings);
    },
    async getTableauToken(context, isEnterpriseReport) {
        const response = await Vue.http.get(`/pando/analytics/tableau/gettoken?isEnterpriseReport=${isEnterpriseReport}`).catch(err => err.response);
        return response
    }
};

const mutations = {
    gotTableauViews(state, data) {
        state.tableauViews = data || [];
    },
    updateTableauView(state, data) {
        const index = (state.tableauViews || []).findIndex(tv => tv.Id == data.Id);
        // Ignore in Embedded mode
        if (index > -1) state.tableauViews.splice(index, 1, data);
    },
    updateReportsSettings(state, settings) {
        state.reportsSettings = settings;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Tableau.js